import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface UIState {
  sidebarCollapsed: boolean
  mobileSidebarOpen: boolean
  /**
   * While true, the page paints its own grey background and MainLayout, below
   * lg, drops <main>'s padding and paints <main> grey on its top half and white
   * on its bottom half. iOS shows <main>'s background when a page is pulled
   * past either end, so a pull at the top shows grey and a pull at the bottom,
   * under a white save bar (Settings), shows white. Not persisted; the page
   * that sets it clears it on unmount.
   */
  pagePaintsBackground: boolean
  toggleSidebar: () => void
  setMobileSidebarOpen: (open: boolean) => void
  setPagePaintsBackground: (white: boolean) => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      mobileSidebarOpen: false,
      pagePaintsBackground: false,
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setMobileSidebarOpen: (open: boolean) => set({ mobileSidebarOpen: open }),
      setPagePaintsBackground: (white: boolean) => set({ pagePaintsBackground: white }),
    }),
    {
      name: 'flowrent-ui',
      partialize: (state) => ({ sidebarCollapsed: state.sidebarCollapsed }),
    }
  )
)
